import { useMemo } from "react";
import styles from "./MisttrackData.module.sass";
import type { AmlHistoryItemData } from "@/store/models";

interface MisttrackDataProps {
  item: AmlHistoryItemData;
  isLoading?: boolean;
}

const MisttrackData = ({ item, isLoading }: MisttrackDataProps) => {
  const additionalTags = useMemo(() => {
    let tags: string[] = [];
    const info = item.extras;

    if (info?.tags?.length) {
      tags = [...info.tags];
    }

    if (info?.services?.use_platform?.length) {
      tags = [...tags, ...info.services.use_platform];
    }

    if (info?.services?.malicious_event?.length) {
      tags = [...tags, ...info.services.malicious_event];
    }

    if (info?.services?.relation_info?.length) {
      tags = [...tags, ...info.services.relation_info];
    }

    return tags.slice(0, 9);
  }, [item.extras]);

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLines}>
            <div className={styles.skeletonLine} />
            <div className={styles.skeletonLine} />
            <div className={styles.skeletonLine} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.entities}>
      <div className={styles.title}>Entities and events</div>

      <div className={styles.list}>
        {additionalTags.map((tag: string) => (
          <div key={tag} className={styles.tag}>{tag}</div>
        ))}
      </div>
    </div>
  );
};

export default MisttrackData;
